import React from 'react';
import useReveal from '../hooks/useReveal';
import useSeo from '../hooks/useSeo';
import SectionHeading from '../components/SectionHeading';
import ServicesGrid from '../components/ServicesGrid';
import ProcessSteps from '../components/ProcessSteps';
import TechnologySection from '../components/TechnologySection';
import IntegrationsSection from '../components/IntegrationsSection';
import { faqs } from '../mock/mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import CTA from '../components/CTA';

export default function Solutions() {
  useReveal('solutions');
  useSeo({ title: 'Solutions | Interscope Ads Performance Marketing', description: 'Mobile user acquisition, retargeting, CTV, programmatic, performance marketing, lead generation, affiliate marketing and app growth.' });
  return (
    <main className="pt-32">
      <section className="relative max-w-7xl mx-auto px-5 md:px-8 pb-4 text-center">
        <span className="reveal inline-block mb-3 text-xs font-semibold tracking-[0.25em] uppercase text-[#2563eb]">Our Solutions</span>
        <h1 className="reveal font-display text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-[1.08] max-w-3xl mx-auto">
          Performance solutions that <span className="text-gradient">move the needle</span>
        </h1>
        <p className="reveal mt-6 text-slate-600 text-lg max-w-2xl mx-auto">
          Full-funnel, data-driven services engineered to acquire quality users and scale measurable growth.
        </p>
      </section>

      <section className="relative max-w-7xl mx-auto px-5 md:px-8 section-pad">
        <ServicesGrid detailed />
      </section>

      <section className="relative max-w-7xl mx-auto px-5 md:px-8 pb-4">
        <SectionHeading eyebrow="How It Works" title="Acquire. Optimize. Scale." subtitle="A transparent, data-driven path from strategy to scale." />
        <ProcessSteps />
      </section>

      <TechnologySection />
      <IntegrationsSection />

      <section className="relative max-w-3xl mx-auto px-5 md:px-8 section-pad">
        <SectionHeading eyebrow="FAQ" title="Questions, answered" />
        <Accordion type="single" collapsible className="reveal space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="glass rounded-xl border-slate-200 px-5">
              <AccordionTrigger className="text-left text-slate-900 font-medium hover:no-underline hover:text-[#2563eb]">{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-500 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      <CTA />
    </main>
  );
}
